module.exports = __webpack_public_path__ + "static/media/proposal.dbc1fcaf.png";